import { BellIcon, BookmarkIcon, ListIcon, type NavItem } from '@huaca/ui';

/**
 * tenders' destinations in the shell's side rail.
 *
 * ONE OF THESE IS REAL. The search screen is the whole product today: `SearchPage` renders on every
 * path and a posting opens as a panel layered over it rather than as a separate screen, so there is
 * exactly one place to go. The other two are signposts — declared `disabled`, rendered as inert
 * muted text with `aria-disabled`, never as links that quietly do nothing.
 *
 * WHY DECLARE THEM AT ALL. A rail with a single item is a rail that has nothing to say, and the
 * point of this module having one is that it is going to. Saying "saved" and "alerts" are coming is
 * information a reader can use; a link that swallows their click is not. Give each one a `path` and
 * drop `disabled` when its screen exists — nothing else here needs to change.
 *
 * Its own module rather than a constant in App.tsx: App.tsx imports `config`, which throws at import
 * time when VITE_API_BASE is unset, and that would make these untestable.
 */
export const NAV_ITEMS: NavItem[] = [
  { path: '/', label: 'כל המכרזים', icon: <ListIcon /> },
  { label: 'שמורים', icon: <BookmarkIcon />, disabled: true },
  { label: 'התראות', icon: <BellIcon />, disabled: true },
];
